import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {WebComponent} from './web/web.component';
import {WritingComponent} from './writing/writing.component';
import {ArtComponent} from './art/art.component';
import {MusicComponent} from './music/music.component';
import {HomeComponent} from './home/home.component';
import {DocFromGmailComponent} from './web/doc-from-gmail/doc-from-gmail.component';
import {SheetFromGmailComponent} from './web/sheet-from-gmail/sheet-from-gmail.component';
import {IlluminatingCoComponent} from './web/illuminating-co/illuminating-co.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'web',
    component: WebComponent
  },
  {
    path: 'writing',
    component: WritingComponent
  },
  {
    path: 'art',
    component: ArtComponent
  },
  {
    path: 'music',
    component: MusicComponent
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
